/**
 * Error boundary: Auto-reload cuando falla la carga de módulos dinámicos.
 * Cubre escenarios post-deploy donde el navegador tiene HTML/assets viejos en cache
 * y los archivos JS con hash anterior ya no existen en el servidor.
 */
function handleModuleLoadError(message?: string) {
  const isModuleError =
    message?.includes('Failed to fetch dynamically imported module') ??
    message?.includes('Importing a module script failed') ??
    message?.includes('Failed to load module script') ??
    message?.includes('MIME type') ??
    message?.includes('text/html') ??
    false;

  if (!isModuleError) return;

  // Evitar loop infinito de reloads (máximo 1 reload cada 10 segundos)
  const lastReload = sessionStorage.getItem('chunk-reload');
  const now = Date.now();

  if (!lastReload || now - Number(lastReload) > 10000) {
    sessionStorage.setItem('chunk-reload', String(now));
    window.location.reload();
  }
}

// Captura errores de import() dinámicos (Promise rejections)
window.addEventListener(
  'unhandledrejection',
  (event: PromiseRejectionEvent) => {
    const reason: unknown = event.reason;
    const message = reason instanceof Error ? reason.message : '';

    handleModuleLoadError(message);
  },
);

// Captura errores de <script type="module"> (errores síncronos de carga)
window.addEventListener(
  'error',
  (event: ErrorEvent) => {
    const message = event.message;

    handleModuleLoadError(message);
  },
  true,
);

await import('./bootstrap');
export {};
